import React, { useEffect, useState } from "react"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import NursingDetail from "./NursingDetail"
import PastNotes from "./PastNotes"
import { getPastAppointmentNotes } from "../../../../core/services/api"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import { calculateAge } from "core/utils/date"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

function NursingNotes({ closePrintModal, patientMOC, appointmentId, readOnly, smartSummaryDetails }: any) {
  const userRole = useSelector((state: any) => state?.user?.role)

  const [show, setShow] = useState(true)
  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const [allOrders, setallOrders] = useState([])
  const [smartSummaryData, setSmartSummaryData] = useState([])

  useEffect(() => {
    getPastAppointmentNotes(patientMOC?.id).then((res) => {
      setallOrders(res)
    })
  }, [])

  useEffect(() => {
    if (smartSummaryDetails) {
      setSmartSummaryData(smartSummaryDetails)
    }
  }, [smartSummaryDetails])

  return (
    <div>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientMOC,
                  false,
                  null,
                  "-"
                )}
                {patientMOC?.mocId}-{patientMOC?.gender}-{calculateAge(patientMOC?.dob)}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="heading-test" style={{ paddingLeft: "25px" }}>
            Nursing Notes
          </Row>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <Box sx={{}}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                TabIndicatorProps={{
                  sx: {
                    bgcolor: "blue",
                    height: "2px",
                    color: "blue",
                  },
                }}
                sx={{
                  "& button:active": {
                    color: "blue",
                  },
                  "& button:selected": {
                    color: "blue",
                  },
                }}
              >
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Nurse Notes"
                  {...a11yProps(0)}
                />
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Past Nurse Notes"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <NursingDetail
                patientInfo={patientMOC}
                appointmentId={appointmentId}
                allOrder={allOrders}
                isEdit="none"
                pastNotes="false"
                smartSummaryData={smartSummaryData}
                readOnly={readOnly}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PastNotes
                patientInfo={patientMOC}
                appointmentId={appointmentId}
                allOrder={allOrders}
                smartSummaryData={smartSummaryData}
                readOnly={readOnly}
              />
            </TabPanel>
          </Box>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  )
}

export default NursingNotes
function handlePrint(arg0: boolean) {
  throw new Error("Function not implemented.")
}
